'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const PPTIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="PPTIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.5 23.5C20.7652 23.5 21.0196 23.3946 21.2071 23.2071C21.3946 23.0196 21.5 22.7652 21.5 22.5V6.473C21.4995 4.88868 20.8697 3.36943 19.7493 2.24933C18.6288 1.12923 17.1093 0.5 15.525 0.5H3.5C3.23478 0.5 2.98043 0.605357 2.79289 0.792893C2.60536 0.98043 2.5 1.23478 2.5 1.5V22.5C2.5 22.7652 2.60536 23.0196 2.79289 23.2071C2.98043 23.3946 3.23478 23.5 3.5 23.5H20.5Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 0.578979V4.49998C16.5 4.7652 16.6054 5.01955 16.7929 5.20709C16.9804 5.39462 17.2348 5.49998 17.5 5.49998H21.42"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 14C8.5 14.3978 8.34196 14.7794 8.06066 15.0607C7.77936 15.342 7.39782 15.5 7 15.5H5.5V12.5H7C7.39782 12.5 7.77936 12.658 8.06066 12.9393C8.34196 13.2206 8.5 13.6022 8.5 14Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 18.499V15.499"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 14C13.5 14.3978 13.342 14.7794 13.0607 15.0607C12.7794 15.342 12.3978 15.5 12 15.5H10.5V12.5H12C12.3978 12.5 12.7794 12.658 13.0607 12.9393C13.342 13.2206 13.5 13.6022 13.5 14Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 18.499V15.499"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5 12.499H19.5"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 12.499V18.499"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

PPTIcon.propTypes = {
  sx: PropTypes.object
}
